document.addEventListener("DOMContentLoaded", () => {
   const toggle = document.getElementById("newsFilterToggle");
   const target = document.getElementById("newsFilter");

   if (toggle && target) {
      toggle.addEventListener("click", () => {
         target.classList.toggle("active");
      });
   }
});
